(function () {
	'use strict';

	// ITG 2026-10-08: how native videos load.
	// Nothing video-related downloads until the visitor first interacts with the page, so the
	// first paint never competes with video (unchanged). After that, each video downloads only
	// when it comes near the screen, and a video hidden at the current screen size
	// (display: none, e.g. the desktop copy on a phone) never downloads. Background videos that
	// autoplay are paused while off screen and resume when they come back.
	// Before this change every video on the page downloaded at once on the first touch.

	var NEAR_SCREEN = '300px 0px';

	function wantsAutoplay(video) {
		return (
			video.hasAttribute('autoplay') ||
			video.hasAttribute('data-video-autoplay') ||
			video.dataset.videoAutoplay === 'true'
		);
	}

	// The slideshow plays and pauses its own slide videos, so we only load those, never pause them.
	function inSlideshow(video) {
		return !!(video.closest && video.closest('slideshow-carousel'));
	}

	function needsSources(video) {
		return Array.prototype.some.call(video.querySelectorAll('source[data-src]'), function (source) {
			return source.dataset.src && source.getAttribute('src') !== source.dataset.src;
		});
	}

	function playMuted(video) {
		video.muted = true;
		video.playsInline = true;
		var p = video.play();
		if (p && typeof p.catch === 'function') p.catch(function () {});
	}

	function hydrateVideo(video) {
		if (!video) return;

		// copy every <source data-src> to src
		video.querySelectorAll('source[data-src]').forEach(function (source) {
			var newSrc = source.dataset.src;
			if (newSrc && source.getAttribute('src') !== newSrc) {
				source.setAttribute('src', newSrc);
			}
		});

		// reload the video after swapping sources
		try { video.load(); } catch (e) {}

		if (wantsAutoplay(video)) playMuted(video);

		video.dataset.hydrated = '1';
	}

	var nearScreen = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			var video = entry.target;
			if (entry.isIntersecting) {
				if (needsSources(video)) {
					hydrateVideo(video);
				} else if (video.dataset.pausedOffscreen === '1') {
					delete video.dataset.pausedOffscreen;
					playMuted(video);
				}
			} else if (!inSlideshow(video) && wantsAutoplay(video) && video.muted && !video.paused) {
				video.pause();
				video.dataset.pausedOffscreen = '1';
			}
		});
	}, { rootMargin: NEAR_SCREEN }) : null;

	function watch(video) {
		if (video.dataset.itgWatched === '1') return;
		video.dataset.itgWatched = '1';
		if (nearScreen) {
			nearScreen.observe(video);
		} else if (needsSources(video)) {
			hydrateVideo(video); // very old browsers: previous behaviour
		}
	}

	function watchExisting() {
		document.querySelectorAll('video[data-video-type="native"]').forEach(watch);
	}

	// watch videos added to the page later (variant changes, quick view, drawers)
	var observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (m) {
			if (m.addedNodes && m.addedNodes.length) {
				m.addedNodes.forEach(function (node) {
					if (!(node instanceof HTMLElement)) return;
					if (node.matches && node.matches('video[data-video-type="native"]')) {
						watch(node);
					} else if (node.querySelectorAll) {
						node.querySelectorAll('video[data-video-type="native"]').forEach(watch);
					}
				});
			}
		});
	});

	var started = false;
	var startEvents = ['mousemove', 'touchstart', 'pointerdown', 'scroll', 'wheel', 'keydown'];

	function startAll() {
		if (started) return;
		started = true;
		startEvents.forEach(function (ev) {
			window.removeEventListener(ev, startAll, { passive: true });
		});
		watchExisting();
		observer.observe(document.documentElement, {
			childList: true,
			subtree: true
		});
	}

	// start on the first interaction (mouse, touch, scroll or keyboard)
	startEvents.forEach(function (ev) {
		window.addEventListener(ev, startAll, { passive: true });
	});
	})();

	// this code for Some ELements  are first hide and show after user intraction..(start)
		// document.addEventListener("DOMContentLoaded", () => {
		// 	document.body.classList.add("itg_before_hide");
		// 	['mousemove', 'click', 'touchstart', 'pointerdown','scroll'].forEach(eventType => {
		// 		window.addEventListener(eventType, () => {
		// 			document.body.classList.remove("itg_before_hide");
		// 		}, { once: true });
		// 	});
		// });

		document.addEventListener("DOMContentLoaded", () => {
			document.body.classList.add("itg_before_hide");
			const events = ['mousemove','click','touchstart','pointerdown','scroll', 'touchmove','wheel'];
			const removeClass = e => {
				document.body.classList.remove("itg_before_hide");
				events.forEach(ev => {
				window.removeEventListener(ev, removeClass, {passive:true,capture:true});
				document.removeEventListener(ev, removeClass, {passive:true,capture:true});
				});
			};
			events.forEach(ev => {
				window.addEventListener(ev, removeClass, {passive:true,capture:true});
				document.addEventListener(ev, removeClass, {passive:true,capture:true});
			});
		});


		// document.addEventListener("DOMContentLoaded", () => {
		// 	document.body.classList.add("itg_before_hide");
		// 	const events = ['touchstart','touchmove','click','pointerdown','scroll','wheel','keydown'];
		// 	const fn = () => {
		// 		document.body.classList.remove("itg_before_hide");
		// 		events.forEach(ev => {
		// 		window.removeEventListener(ev, fn, {passive:true,capture:true});
		// 		document.removeEventListener(ev, fn, {passive:true,capture:true});
		// 		});
		// 	};
		// 	events.forEach(ev => {
		// 		window.addEventListener(ev, fn, {passive:true,capture:true});
		// 		document.addEventListener(ev, fn, {passive:true,capture:true});
		// 	});
		// });

	// this code for Some ELements  are first hide and show after user intraction..(End)